import styled from "styled-components";

import { BaseButton } from "@shared/styles/common.styled";

export const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const EditButton = styled(BaseButton)`
  background-color: transparent;
  border: none;
  padding: 7px;
  min-width: auto;
  flex: 1;
  margin: 0 0 0 8px;
`;

export const CompletedButton = styled(BaseButton)`
  background: #ff5101;
  border: 1px solid #ff5101;
`;
